import ReactDOM from "react-dom/client";
import App from "./App";
import "./App.css";
import { MsalProvider, useIsAuthenticated, useMsal } from "@azure/msal-react";
import { msalInstance } from "./features/auth/msalInstance";
import { attachTokenInterceptor } from "./services/apiClient";
import { CONFIG } from "./config";

import Loader from "./components/ui/Loader";
import DevTools from "./components/dev/DevTools";
import { FindmoreAppNotification } from "@react-solutions-ui/findmore-ui";

async function bootstrap() {
  console.log("REACT_APP_AUTH_CLIENT_ID:", CONFIG.AUTH_CLIENT_ID);
  await msalInstance.initialize();

  let account = msalInstance.getActiveAccount();
  if (!account) {
    const accounts = msalInstance.getAllAccounts();
    if (accounts.length > 0) {
      msalInstance.setActiveAccount(accounts[0]);
      account = accounts[0];
    }
  }

  if (account) attachTokenInterceptor(msalInstance, account);

  const root = ReactDOM.createRoot(document.getElementById("root")!);
  root.render(
    <MsalProvider instance={msalInstance}>
      <AuthGate>
        <App />
      </AuthGate>
      <FindmoreAppNotification />
      <DevTools />
    </MsalProvider>
  );
}

bootstrap();

function AuthGate({ children }: { children: React.ReactNode }) {
  const isAuthenticated = useIsAuthenticated();
  const { accounts, inProgress, instance } = useMsal();

  if (inProgress === "startup" || inProgress === "handleRedirect") {
    return <Loader text="Inicializando sessão..." />;
  }

  if (isAuthenticated && accounts.length > 0) {
    attachTokenInterceptor(instance, accounts[0]);
  }

  return <>{children}</>;
}
